import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { rejoinMapImages as t } from "./rejoinMapImages.mjs";
import { useQuery as n } from "@maat/store-hooks";
import { propertiesApi as r } from "@maat/api-main";
import { useMemo as i } from "react";
import { canonicalZoom as a, snapBbox as o } from "@maat/utils";
//#region src/properties/useMapSuggestionsQuery.ts
var s = (s, c = !0) => {
	let l = i(() => s && {
		...s,
		zoom: a(s.zoom),
		bbox: o(s.bbox, s.zoom)
	}, [s]);
	return n({
		queryKey: e.mapSuggestions(l),
		queryFn: async () => {
			let e = await r.getMapSuggestions(l);
			return {
				...e,
				sections: e.sections.map((n) => ({
					...n,
					items: n.items.map((n) => t(n, e.imageBase))
				}))
			};
		},
		enabled: c && !!l?.bbox,
		placeholderData: (e) => e
	});
};
//#endregion
export { s as useMapSuggestionsQuery };
